import { render, staticRenderFns } from "./poptip.vue?vue&type=template&id=9f04dd88"
import script from "./poptip.vue?vue&type=script&lang=js"
export * from "./poptip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports